import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-center justify-between gap-3 px-6 py-3.5" }
const _hoisted_2 = { class: "flex items-center gap-2 text-sm text-gray-600" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "font-medium text-gray-900" }
const _hoisted_5 = { class: "font-medium text-gray-900" }
const _hoisted_6 = { class: "font-medium text-gray-900" }
const _hoisted_7 = { key: 1 }

import { ChartBarIcon } from '@heroicons/vue/20/solid'

import NeueButton from '@/components/neue/NeueButton.vue'

import { formatMoney } from './websiteReport'


export default {
  __name: 'ChannelReportLink',
  props: {
  summary: { type: Object, default: null },
  days: { type: Number, default: 30 },
  to: { type: String, required: true },
  emptyText: { type: String, default: 'See how many inquiries turn into paid orders.' }
},
  setup(__props) {



return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ChartBarIcon), {
        class: "h-4 w-4 shrink-0 text-gray-400",
        "aria-hidden": "true"
      }),
      (__props.summary)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createTextVNode(" Last " + _toDisplayString(__props.days) + " days · ", 1),
            _createElementVNode("b", _hoisted_4, _toDisplayString(__props.summary.leads), 1),
            _createTextVNode(" " + _toDisplayString(__props.summary.leads === 1 ? 'lead' : 'leads') + " · ", 1),
            _createElementVNode("b", _hoisted_5, _toDisplayString(__props.summary.paid_orders), 1),
            _createTextVNode(" paid " + _toDisplayString(__props.summary.paid_orders === 1 ? 'order' : 'orders') + " · ", 1),
            _createElementVNode("b", _hoisted_6, _toDisplayString(_unref(formatMoney)(__props.summary.revenue_cents)), 1)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.emptyText), 1))
    ]),
    _createVNode(_component_router_link, {
      to: __props.to,
      class: "shrink-0"
    }, {
      default: _withCtx(() => [
        _createVNode(NeueButton, {
          type: "secondary",
          size: "sm"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("View report", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

}